module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsPSIjNjczMTQ3Ij4KPHJlY3Qgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIHJ4PSIxNSUiLz4KPHJlY3QgeD0iNTYiIHk9IjExMSIgd2lkdGg9IjQwMCIgaGVpZ2h0PSIyOTAiIHJ4PSI0NCIgZmlsbD0iI2ZmZiIvPgo8cGF0aCBkPSJtODkgMTQ4aDMzNHYyMTZoLTMzNCIvPgo8cGF0aCBkPSJtNDM3IDE1OC0xNTcgMTM2Yy0xNiAxNC0zMiAxNC00OCAwbC0xNTctMTM2bTM0OSAyMDYtMTA1LTEwNW0tMjMxIDEwNSAxMDctMTA3IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMjQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/email.svg
// module id = ./src/images/icons/email.svg
// module chunks = 114276838955818